
//uma pagina com uma lista de documentos necessários para o processo de declaração de imposto de renda, com uma breve descrição de cada documento e um link para upload de um modelo de cada documento.
//são cinco colunas sendo a primeiro coluna com numero de item ordenado usando 5% da linha, a segunda coluna com o nome do documento e breve descrição do documento usando o espaço restante da linha, a terceira coluna na parte final da linha com 5% da linha com indicador de icone se foi feito upload ou está pendente o upload do documento, e a quarta coluna também ao final e com 5% da linha com um link para upload do modelo do documento. a ultima coluna também no final e com 5% da linha com um checkbbox indicativo de não aplicado.
//a lista de documentos segue a ordem crescente de 1 e os nomes e descrição dos documentos são os seguintes:
//1	Driver License (spouse inclusively): Upload front side only
//2	Social Security Card (spouse and dependents): Upload front side only 
//3	Income from payroll (spouse inclusively): Upload Form W-2
//4	Income from interest and dividends, less than $1,500: Upload Forms 1099-INT and 1099-DIV
//5	Income from retirement account: Upload Form Form 1099-R
//6	Income from social security benefits: Upload Form SSA-1099
//7	Income from unemployment: Upload Form 1099-G
//8	Expenses with student loan interest: Upload Form 1098-E
//9	Expenses with tuitions to colleges or universities, dependents inclusively: Upload Form 1098-T
//10 Expenses with health insurance premiums marketplace: Upload Form 1095-A
//11 Expenses with car loan interest: Upload Form Form 1098-VLI
//12 Estimated taxes paid in 2025 or in 2026 related to 2025 calendar year: Upload receipts
//13 Tax return filed in 2025 related to 2024 calendar year: Upload Form 1040 and other Forms and Schedules
//14 In case of tax refund, inform the name of the bank, routing number and account number to receive the credit from the IRS
//15 In case of tax owed, inform (YES) whether the tax can be widrawal from the bank account informed above, or (NO) whether you prefer to pay later as soon as the IRS send you a CP14 Notice (penalty and interest aply)
//adiciona duas novas linhas e devem ficar um pouco mais separadas das outras linhas para destacar a importância dessas informações para o processo de declaração de imposto de renda, e essas linhas devem ter os seguintes textos traduzidos para o inglês: o primeiro será: Upload do recibo de pagamento pelo seriviço de declaração de imposto de renda, e o segundo será: download do recibo de transmissão e declaração do imposto de renda.

import axios from "axios";
import React, {use, useEffect, useState, replace} from "react";
import '../styles/global.css'; // Seu CSS global
import { useParams, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { encryptPassword, decryptPassword, encryptString, decryptString } from "../utils/crypto";
import { v4 as uuidv4 } from 'uuid';

function Documents() {
    const [IdTaxPayer, setIdTaxPayer] = useState(0);
    const { reqCodeGUID } = useParams();
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [taxpayer, setTaxPayer] = React.useState({
        IdTaxPayer: 0,
        txpFullName: '',
        txpDateOfBirth: '',
        txpFullAddress: '',
        txpCity: '',
        txpState: '',
        txpZipCode: '',
        txpCellPhone: '',
        txpOccupation: '',
        txpEmail: '',
        txpSSN: '',
        txpITIN: '',
        txpPassword: '',
        txpDL: '',
        txpSSC: '',
        txpSpouseFullName: '',
        txpSpouseDateOfBirth: '',
        txpSpouseCellPhone: '',
        txpSpouseOccupation: '',
        txpSpouseEmail: '',
        txpSpouseSSN: '',
        txpSpouseSSC: '',
        txpD1FullName: '',
        txpD1DateOfBirth: '',
        txpD1Relationship: '',
        txpD2FullName: '',
        txpD2DateOfBirth: '',
        txpD2Relationship: '',
        txpD3FullName: '',
        txpD3DateOfBirth: '',
        txpD3Relationship: '',
        txpD4FullName: '',
        txpD4DateOfBirth: '',
        txpD4Relationship: '',
        txpCreatedIn: new Date().toISOString(),
        txpCreatedBy: '',
        txpUpdatedIn: new Date().toISOString(),
        txpUpdatedBy: '',
        txpCodeGUID: uuidv4(),
        txpStatus: 1
    });

    const [taxpayerInfo, setTaxpayerInfo] = React.useState({
        IdTaxPayer: 0,
        txpFullName: '',
        txpDateOfBirth: '',
        txpFullAddress: '',
        txpCity: '',
        txpState: '',
        txpZipCode: '',
        txpCellPhone: '',
        txpOccupation: '',
        txpEmail: '',
        txpSSN: '',
        txpITIN: '',
        txpPassword: '',
        txpDL: '',
        txpSSC: '',
        txpSpouseFullName: '',
        txpSpouseDateOfBirth: '',
        txpSpouseCellPhone: '',
        txpSpouseOccupation: '',
        txpSpouseEmail: '',
        txpSpouseSSN: '',
        txpSpouseSSC: '',
        txpD1FullName: '',
        txpD1DateOfBirth: '',
        txpD1Relationship: '',
        txpD2FullName: '',
        txpD2DateOfBirth: '',
        txpD2Relationship: '',
        txpD3FullName: '',
        txpD3DateOfBirth: '',
        txpD3Relationship: '',
        txpD4FullName: '',
        txpD4DateOfBirth: '',
        txpD4Relationship: '',
        txpCreatedIn: '',
        txpCreatedBy: '',
        txpUpdatedIn: '',
        txpUpdatedBy: '',
        txpCodeGUID: '',
        txpStatus: 1
    });
    
    const [documents, setDocuments] = React.useState([]);

    console.log(documents);
    console.log(reqCodeGUID);
    //set a variavel com o valor do sessionStorage.getItem('IdTaxPayer') 
    //e toda vez que a variavel for atualizada, atualizar o valor da variavel IdTaxPayer
    useEffect(() => {
        setIdTaxPayer(sessionStorage.getItem('IdTaxPayer'));
    }, [IdTaxPayer]);

    //obtem os dados do tax payer usando o IdTaxPayer e atualiza a variavel taxpayerInfo 
    //com os dados obtidos, e toda vez que a variavel taxpayerInfo for atualizada, 
    // atualizar a variavel taxpayer com os dados obtidos e descriptografados usando a 
    // função decryptString para os campos que foram criptografados.
    useEffect(() => {
        if(IdTaxPayer && IdTaxPayer > 0) {
            setIsLoading(true);
            const dataToSend = { IdTaxPayer: IdTaxPayer };
            axios.post(process.env.REACT_APP_API_URL + `/routes.php?method=getTaxPayerById`,
                dataToSend,
                { headers: {
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
                })
            .then(response => {
                if(response.data && parseInt(response.data.IdTaxPayer) > 0) {
                    // setTaxpayerInfo(response.data);
                    // setTaxPayer(response.data);
                    taxpayer['IdTaxPayer'] = response.data.IdTaxPayer;
                    taxpayer['txpFullName'] = response.data.txpFullName ? decryptString(response.data.txpFullName) : '';
                    taxpayer['txpDateOfBirth'] = response.data.txpDateOfBirth ? decryptString(response.data.txpDateOfBirth) : '';
                    taxpayer['txpFullAddress'] = response.data.txpFullAddress ? decryptString(response.data.txpFullAddress) : '';
                    taxpayer['txpCity'] = response.data.txpCity ? decryptString(response.data.txpCity) : '';
                    taxpayer['txpState'] = response.data.txpState ? decryptString(response.data.txpState) : '';
                    taxpayer['txpZipCode'] = response.data.txpZipCode ? decryptString(response.data.txpZipCode) : '';
                    taxpayer['txpCellPhone'] = response.data.txpCellPhone ? decryptString(response.data.txpCellPhone) : '';
                    taxpayer['txpOccupation'] = response.data.txpOccupation ? decryptString(response.data.txpOccupation) : '';
                    taxpayer['txpEmail'] = response.data.txpEmail;
                    taxpayer['txpSSN'] = response.data.txpSSN ? decryptString(response.data.txpSSN) : '';
                    taxpayer['txpITIN'] = response.data.txpITIN ? decryptString(response.data.txpITIN) : '';
                    taxpayer['txpPassword'] = "";
                    taxpayer['txpDL'] = response.data.txpDL ? decryptString(response.data.txpDL) : '';
                    taxpayer['txpSSC'] = response.data.txpSSC ? decryptString(response.data.txpSSC) : '';
                    taxpayer['txpSpouseFullName'] = response.data.txpSpouseFullName ? decryptString(response.data.txpSpouseFullName) : '';
                    taxpayer['txpSpouseDateOfBirth'] = response.data.txpSpouseDateOfBirth ? decryptString(response.data.txpSpouseDateOfBirth) : '';
                    taxpayer['txpSpouseCellPhone'] = response.data.txpSpouseCellPhone ? decryptString(response.data.txpSpouseCellPhone) : '';
                    taxpayer['txpSpouseOccupation'] = response.data.txpSpouseOccupation ? decryptString(response.data.txpSpouseOccupation) : '';
                    taxpayer['txpSpouseEmail'] = response.data.txpSpouseEmail ? decryptString(response.data.txpSpouseEmail) : '';
                    taxpayer['txpSpouseSSN'] = response.data.txpSpouseSSN ? decryptString(response.data.txpSpouseSSN) : '';
                    taxpayer['txpSpouseSSC'] = response.data.txpSpouseSSC ? decryptString(response.data.txpSpouseSSC) : '';
                    taxpayer['txpD1FullName'] = response.data.txpD1FullName ? decryptString(response.data.txpD1FullName) : '';
                    taxpayer['txpD1DateOfBirth'] = response.data.txpD1DateOfBirth ? decryptString(response.data.txpD1DateOfBirth) : '';
                    taxpayer['txpD1Relationship'] = response.data.txpD1Relationship ? decryptString(response.data.txpD1Relationship) : '';
                    taxpayer['txpD2FullName'] = response.data.txpD2FullName ? decryptString(response.data.txpD2FullName) : '';
                    taxpayer['txpD2DateOfBirth'] = response.data.txpD2DateOfBirth ? decryptString(response.data.txpD2DateOfBirth) : '';
                    taxpayer['txpD2Relationship'] = response.data.txpD2Relationship ? decryptString(response.data.txpD2Relationship) : '';
                    taxpayer['txpD3FullName'] = response.data.txpD3FullName ? decryptString(response.data.txpD3FullName) : '';
                    taxpayer['txpD3DateOfBirth'] = response.data.txpD3DateOfBirth ? decryptString(response.data.txpD3DateOfBirth) : '';
                    taxpayer['txpD3Relationship'] = response.data.txpD3Relationship ? decryptString(response.data.txpD3Relationship) : '';
                    taxpayer['txpD4FullName'] = response.data.txpD4FullName ? decryptString(response.data.txpD4FullName) : '';
                    taxpayer['txpD4DateOfBirth'] = response.data.txpD4DateOfBirth ? decryptString(response.data.txpD4DateOfBirth) : '';
                    taxpayer['txpD4Relationship'] = response.data.txpD4Relationship ? decryptString(response.data.txpD4Relationship) : '';
                    taxpayer['txpCreatedIn'] = response.data.txpCreatedIn;
                    taxpayer['txpCreatedBy'] = response.data.txpCreatedBy;
                    taxpayer['txpUpdatedIn'] = response.data.txpUpdatedIn;
                    taxpayer['txpUpdatedBy'] = response.data.txpUpdatedBy;
                    taxpayer['txpCodeGUID'] = response.data.txpCodeGUID;
                    setIsLoading(false);
                }
            })
            .catch(error => {
                if(error && error.Message) {
                    alert(error.Message);
                } else {
                    alert('An error occurred while fetching the tax payer.');
                }
            });
        }
    }, [IdTaxPayer]);

    //obtem a lista de documentos necessários para o processo de declaração de imposto de renda 
    // usando o reqCodeGUID e atualiza a variavel documents com os dados obtidos, 
    // e toda vez que a variavel documents for atualizada, atualizar a tabela com a 
    // lista de documentos.
    useEffect(() => {
        if(reqCodeGUID && reqCodeGUID.length > 0) {
            setIsLoading(true);
            const dataToSend = { reqCodeGUID: reqCodeGUID };
            axios.post(process.env.REACT_APP_API_URL + `/routes.php?method=getDocumentsByReqCodeGUID`,
                dataToSend,
                { headers: {
                    'X-Access-Token' : tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
                })
            .then(response => {
                console.log(response.data);
                if(response.data) {
                    setDocuments(response.data);
                    setIsLoading(false);
                }
            })
            .catch(error => {
                if(error && error.Message) {
                    alert(error.Message);
                    setIsLoading(false);
                } else {
                    alert('An error occurred while fetching the documents.');
                    setIsLoading(false);
                }
            });
        }
    }, [reqCodeGUID]);

    function handleUpload(document) {
        alert('Upload for document: ' + document.docDescription);
    }

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div className='headerMain'>
                    <div className='mb2'>
                        <label>Documents - {taxpayer.txpFullName}</label>
                    </div>
                    <div className='pr4 pl4'>
                        <label className='labelTitulo' >Please upload the documents listed below to complete your tax return process. If you have any questions about the required documents, please contact us.
                        </label>
                    </div>
                </div>
                <div className="pr8 pl8 mt2 text-align-left">
                    <div className='tabelaPadrao'>
                        <table className='tabelaDados'>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }}>#</th>
                                    <th style={{ width: '80%' }}>Document</th>
                                    <th style={{ width: '5%' }}>Status</th>
                                    <th style={{ width: '5%' }}>Upload</th>
                                    <th style={{ width: '5%' }}>N/A</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? 
                                    <tr>
                                        <td colSpan="5" className='text-align-center'>
                                            <CircularProgress />
                                        </td>
                                    </tr>
                                 : 
                                     
                                        documents
                                        .filter(val => {
                                            return val.docOrder >= 1 && val.docOrder <= 150;
                                        })
                                        .map((document) => (
                                            <tr>
                                                <td>
                                                    {/* 1  */}
                                                    {document.docOrder}
                                                </td>
                                                <td>
                                                    {/* description */}
                                                    {document.docDescription}
                                                </td>
                                                <td className='text-align-center'>
                                                    {/* pendente */}
                                                    {document.docURL ? (
                                                        <span role="img" aria-label="uploaded">✅</span>
                                                    ) : (
                                                        <span role="img" aria-label="pending">⏳</span>
                                                    )}
                                                </td>
                                                <td className='text-align-center'>
                                                    {/* upload */}
                                                    {!document.docURL && (
                                                        <button onClick={() => handleUpload(document)}>Upload</button>
                                                    )}
                                                </td>
                                                <td className='text-align-center'>
                                                    {/* checkbox */}
                                                    {!document.docURL && (
                                                        <input type="checkbox" />
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                     
                                    
                                }
                                
                            </tbody>
                        </table>
                    </div>
                </div>

            </main>
        </div>
    );
}

export default Documents;